import{jsx as o}from"react/jsx-runtime";import{Loader as r}from"../../Loader/Loader.js";import{ColorBlueGray50 as t}from"../../../tokens/js/tokens.js";const e=()=>o(r,{color:t});export{e as LoadingIndicator};
